import { IS_PRODUCTION } from '@/constants'
import { isMIUI } from 'react-device-detect'
import { SerializedStyles } from '@emotion/react'
import {
  css,
  makeStyles,
  RebrandedThemeOptionalProperties,
} from '@conexasaude/conexa-hero'

type UseGlobalStylesProps = {
  height?: string
}

const headerMUIU = isMIUI ? '48px' : '32px'

const useGlobalStyles = (
  theme: RebrandedThemeOptionalProperties,
  props?: UseGlobalStylesProps,
): Record<string, SerializedStyles> => {
  const styles = makeStyles<UseGlobalStylesProps>({
    mainContainer: css`
      display: flex;
      flex-direction: column;
      min-height: 100vh;
      margin-top: ${IS_PRODUCTION ? '0px' : headerMUIU};
      /* mobile viewport bug fix */
      min-height: -webkit-fill-available;
    `,

    global: (_theme, props) => {
      return css`
        .hero-toast_content {
          > span {
            max-width: 367px;
          }
        }

        .chatlayer-chatbox-wrapper {
          max-height: 540px !important;
          left: 0 !important;
          right: unset !important;
          z-index: 9999;

          @media (max-width: 639px) {
            width: 100vw !important;
            height: ${props?.height || '100vh'} !important;
            max-height: unset !important;
          }

          & > .chatlayer-chatbox-button {
            align-self: flex-start !important;
          }
        }

        .chatlayer-chatbox-button {
          display: none !important;
        }

        .chatlayer-iframe {
          @media (max-width: 639px) {
            position: absolute !important;
            top: 0px !important;
            left: 0px !important;
            right: 0px !important;
            width: 100vw !important;
            z-index: 999 !important;
          }
        }

        .buorg {
          background-color: ${theme.colors.brand.primary[100]} !important;
          border-color: ${theme.colors.brand.primary[500]} !important;
        }

        .buorg-pad {
          padding: 12px 16px !important;
        }

        .buorg-buttons {
          margin-top: 16px;
        }

        #buorgul {
          display: inline-flex !important;
          align-items: center !important;
          height: 55px !important;
          padding-left: 16px !important;
          padding-right: 16px !important;
          border: 2px solid ${theme.colors.brand.primary[300]} !important;
          background-color: ${theme.colors.brand.primary[300]} !important;
          border-radius: 8px !important;
          color: ${theme.colors.background.white} !important;
          box-shadow: none !important;
          box-sizing: border-box !important;

          &:hover {
            background-color: ${theme.colors.brand.primary[400]} !important;
            border-color: ${theme.colors.brand.primary[400]} !important;
          }
        }

        #buorgig {
          display: inline-flex !important;
          align-items: center !important;
          height: 55px !important;
          padding-left: 16px !important;
          padding-right: 16px !important;
          border: 2px solid ${theme.colors.brand.primary[300]} !important;
          background-color: transparent !important;
          border-radius: 8px !important;
          color: ${theme.colors.brand.primary[300]} !important;
          box-shadow: none !important;
          box-sizing: border-box !important;

          &:hover {
            background-color: ${theme.colors.brand.primary[100]} !important;
          }
        }

        #buorgpermanent {
          display: inline-flex !important;
          align-items: center !important;
          height: 55px !important;
          padding-left: 16px !important;
          padding-right: 16px !important;
          border: 2px solid ${theme.colors.brand.primary[300]} !important;
          background-color: ${theme.colors.brand.primary[300]} !important;
          border-radius: 8px !important;
          color: ${theme.colors.background.white} !important;
          box-shadow: none !important;
          box-sizing: border-box !important;

          &:hover {
            background-color: ${theme.colors.brand.primary[400]} !important;
            border-color: ${theme.colors.brand.primary[400]} !important;
          }
        }

        .environmentIdentifier {
          position: fixed;
          top: 0;
          width: 100%;
          z-index: 5;
        }

        * {
          -webkit-font-smoothing: antialiased;
          -moz-osx-font-smoothing: grayscale;
        }

        body {
          background-color: ${theme.colors.background.gray} !important;
        }

        #app {
          background-color: ${theme.colors.background.gray};

          .navContainer {
            width: 100%;

            height: auto;
          }
        }

        .mainContainer {
          .navContainer {
            width: 100%;

            height: auto;
          }
        }
      `
    },
  })

  return styles(props)
}

export { useGlobalStyles }
